import { defineStore } from 'pinia';
import { ref } from 'vue';
import { useAuthStore } from '../stores/auth';
import Prompt from '@/types/Prompt';
import PaginatedPrompt from '@/types/PaginatedPrompt';

export const usePromptStore = defineStore('prompts', () => {
    const apiUrl = process.env.VUE_APP_DJANGO_BACKEND
    const authStore = useAuthStore();
    const prompts = ref<Prompt[]>([]);
    const loading = ref<boolean>(true);
    const error = ref<string | null>(null);
    const allPrompts = ref<PaginatedPrompt>();
  
    const deletePrompt = async (uuid: string, imageUrl: string | null) => {
        if (!imageUrl) throw new Error('No image URL provided');
      const response = await fetch(`${apiUrl}/api/prompts/${uuid}/`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authStore.session?.access_token}`,
        },
        body: JSON.stringify({ image_url: imageUrl }),
      });
  
      if (!response.ok) {
        throw new Error(await response.text());
      }
    };

    const fetchPrompts = async (accessToken: string, visitor: string) => {
      if (accessToken) { 
        try {
          const response = await fetch(`${apiUrl}/api/prompts/`, {
            headers: { Authorization: `Bearer ${accessToken}` },
          });

          if (!response.ok) {
            const errorMessage = `Error: ${response.status} ${response.statusText}`;
            throw new Error(errorMessage);
          }
          prompts.value = await response.json();

          
        } catch (err) {
          error.value = err instanceof Error ? err.message : 'An error occurred';
        } finally {
          loading.value = false;
        }
      }
    };

    const fetchAllPrompts = async (accessToken: string, offset = 0) => {
      if (accessToken) {
        try {
          const response = await fetch(`${apiUrl}/api/prompts/explore/?limit=10&offset=${offset}`, {
            headers: { Authorization: `Bearer ${accessToken}`},
          });

          if (!response.ok) {
            const ErrorMessage = `Error: ${response.status} ${response.statusText}`;
            throw new Error(ErrorMessage);
          }

          const data: PaginatedPrompt = await response.json()
          allPrompts.value = offset === 0
            ? data
            : { ...data, result: [...(allPrompts.value?.result ?? []), ...data.result] }

          } catch (err) {
            error.value = err instanceof Error ? err.message : 'An error occurred';
          } finally {
            loading.value = false;
          }
        }
      }
  
    return { prompts, allPrompts, deletePrompt, fetchPrompts, fetchAllPrompts };
  });